import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { leavesAPI, employeesAPI } from '../../lib/api';

const Leave = () => {
  const [leaves, setLeaves] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [leavesRes, employeesRes] = await Promise.all([
        leavesAPI.getAll(),
        employeesAPI.getAll()
      ]);
      setLeaves(leavesRes.data);
      setEmployees(employeesRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getEmployeeName = (empId) => {
    const emp = employees.find(e => e.id === empId);
    return emp?.name || '-';
  };

  const columns = [
    { key: 'employee_id', label: 'Employee', render: (val) => getEmployeeName(val) },
    { key: 'leave_type', label: 'Type' },
    { key: 'start_date', label: 'Start Date', type: 'date' },
    { key: 'end_date', label: 'End Date', type: 'date' },
    { key: 'reason', label: 'Reason' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const formFields = [
    {
      name: 'employee_id',
      label: 'Employee',
      type: 'select',
      required: true,
      options: employees.map(e => ({ value: e.id, label: e.name })),
    },
    {
      name: 'leave_type',
      label: 'Leave Type',
      type: 'select',
      required: true,
      options: [
        { value: 'annual', label: 'Annual Leave' },
        { value: 'sick', label: 'Sick Leave' },
        { value: 'personal', label: 'Personal Leave' },
        { value: 'maternity', label: 'Maternity Leave' },
        { value: 'paternity', label: 'Paternity Leave' },
        { value: 'unpaid', label: 'Unpaid Leave' },
      ],
    },
    { name: 'start_date', label: 'Start Date', type: 'date', required: true },
    { name: 'end_date', label: 'End Date', type: 'date', required: true },
    { name: 'reason', label: 'Reason', type: 'textarea', placeholder: 'Leave reason' },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'pending',
      options: [
        { value: 'pending', label: 'Pending' },
        { value: 'approved', label: 'Approved' },
        { value: 'rejected', label: 'Rejected' },
      ],
    },
  ];

  const handleAdd = async (data) => {
    await leavesAPI.create(data);
    fetchData();
  };

  const handleEdit = async (id, data) => {
    await leavesAPI.update(id, data);
    fetchData();
  };

  const handleDelete = async (id) => {
    await leavesAPI.delete(id);
    fetchData();
  };

  return (
    <DataTable
      title="Leave Management"
      description="Manage employee leave requests"
      data={leaves}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default Leave;
